export const STATION_OPERATIONS_JOIN_REQUIRED = 'STATION_OPERATIONS_JOIN_REQUIRED';
export const STATION_OPERATIONS_JOIN_FAILED = 'STATION_OPERATIONS_JOIN_FAILED';
export const STATION_OPERATIONS_SESSION_NOT_VISIBLE = 'STATION_OPERATIONS_SESSION_NOT_VISIBLE';
export const STATION_OPERATIONS_FINAL_ACTION_BLOCKED = 'STATION_OPERATIONS_FINAL_ACTION_BLOCKED';
export const STATION_OPERATIONS_PRIMARY_REASSIGNMENT_BLOCKED =
  'STATION_OPERATIONS_PRIMARY_REASSIGNMENT_BLOCKED';
